import React from "react";
import { AutocompleteInput, ReferenceInput, required } from "react-admin";
import { useField } from "react-final-form";

const SchoolInput = ({ parentCallback }: any) => {
  const level = useField("levelId");
  const levelGroup = useField("levelGroupId");
  const academicYear = useField("academicYearId");
  const ccaAcademicYear = useField("ccaAcademicYearId");
  const date = useField("date");
  const fixLocation = useField("fixedLocationId");

  return (
    <ReferenceInput
      label="School"
      source="schoolId"
      reference="schools"
      validate={required()}
      filterToQuery={(searchText) => {
        if (searchText !== "") return { search: searchText };
      }}
      onChange={() => {
        academicYear.input.value !== "" && academicYear.input.onChange("");
        ccaAcademicYear.input.value !== "" && ccaAcademicYear.input.onChange("");
        level.input.value !== "" && level.input.onChange("");
        levelGroup.input.value !== "" && levelGroup.input.onChange("");
        date.input.value !== "" && date.input.onChange("");
        fixLocation.input.value !== "" && fixLocation.input.onChange("");

        parentCallback && parentCallback(0);
      }}
    >
      <AutocompleteInput optionText="name" optionId="id" />
    </ReferenceInput>
  );
};

export default SchoolInput;
